<script>
import { mapGetters } from "vuex";
import HorizontalStackedBarChart from "@/shared/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.vue";

export default {
  name: "TrackerOrganizationsBySector",
  components: { HorizontalStackedBarChart },
  data() {
    return {
      colors: {
        optionList_selfAssessment_general_classification_sector_agriculture: "#19A39C",
        optionList_selfAssessment_general_classification_sector_industry: "#F32474",
        optionList_selfAssessment_general_classification_sector_nonMarket: "#B7C51C",
        optionList_selfAssessment_general_classification_sector_market: "#22C2E5",
        optionList_selfAssessment_general_classification_sector_academia: "#FFA700",
      },
      groups: [
        "optionList_selfAssessment_general_classification_sector_agriculture",
        "optionList_selfAssessment_general_classification_sector_industry",
        "optionList_selfAssessment_general_classification_sector_market",
        "optionList_selfAssessment_general_classification_sector_nonMarket",
        "optionList_selfAssessment_general_classification_sector_academia",
      ],
      config: {
        width: 400,
        height: 220,
        marginTop: 0,
        marginBottom: 0,
        axisLabelSpacePercentage: 25,
      },
    };
  },
  computed: { ...mapGetters(["getTrackerOrganizationsBySector"]) },
  watch: {
    getTrackerOrganizationsBySector: {
      handler: function () {
        this.formatEmployeesByOrganizationSize();
      },
    },
    deep: true,
  },
  mounted() {
    this.formatEmployeesByOrganizationSize();
  },
  methods: {
    formatEmployeesByOrganizationSize: function () {
      return this.getTrackerOrganizationsBySector.data
        .filter((empl) => !!empl._id)
        .map((employees) => {
          return {
            group: employees._id,
            subGroup: employees._id,
            value: employees.count,
          };
        });
    },
  },
};
</script>

<template>
  <div>
    <horizontal-stacked-bar-chart
      :chart-data="formatEmployeesByOrganizationSize()"
      :colors="colors"
      :custom-group-sorting="groups"
      :config="config"
      :parent-height="false"
    />
  </div>
</template>

<style scoped lang="scss">

</style>
